import React from 'react';
import HeaderTitle from '../../components/HeaderTitle/HeaderTitle';
import Headers from '../../Headers';
import ScreenTabsNavigation, { IScreenTab } from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';

interface IProps {
  title: string;
  options: IScreenTab[];
  navigationClassName?: string;
  isBeta?: boolean;
}

const ScreenHeader: React.FC<IProps> = (props: IProps): JSX.Element => {
  return (
    <>
      <Headers>
        <HeaderTitle title={props.title} isBeta={props.isBeta} />
      </Headers>
      <ScreenTabsNavigation className={`mt-6 mb-4 ${props.navigationClassName || ''}`} options={props.options} />
    </>
  );
};

export default ScreenHeader;
